// extracted by mini-css-extract-plugin
module.exports = {"titleBarActionsContainer":"_1ZrIoB7w","iconButton":"_2D8ThHLx","actionsDropdown":"_2jYf5DyS","shareIconLabel":"_2RIEgXrz","shareIconDisabled":"_2XGgX_Yl"};